import instance from '@/common/service/api/Axios';
import { ReviewsProps, RecentReviewsProps } from '../domain/Reviews.domain';
import { ApiUrls } from '@/common/domain/Endpoints.domain';

export async function fetchReviews(params = {}) {
    const { data } = await instance.get<ReviewsProps>(ApiUrls.review.list, { params });

    if (data && Array.isArray(data?.items)) {
        return data;
    }

    return null;
}

export async function fetchRecentReviews(params = {}) {
    const { data } = await instance.get<RecentReviewsProps>(ApiUrls.review.recent, { params });

    if (data && Array.isArray(data?.items)) {
        return data.items;
    }

    return null;
}
